<template>
  <ats
    v-bind="$props"
    service="cornerstone"
    :savingConf="savingConf"
    :credential="{ company: '', clientId: '', clientSecret: '', url: '', externalApi: false, externalApiPath: '', submissionSource: '', submissionSourceName: '' }"
    :cached="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div>
        <label for="externalApi">API externe</label>
        <input type="checkbox" v-model="credential.externalApi" id="externalApi" name="externalApi"/>
        <modified :enable="value.credential.externalApi !== credential.externalApi"/>
      </div>
      <div v-if='credential.externalApi'>
        <label for="url">url</label>
        <input v-model="credential.url" id="url" name="url"/>
        <modified :enable="value.credential.url !== credential.url"/>
      </div>
      <div v-else>
        <label for="company">company</label>
        <input v-model="credential.company" id="company" name="company"/>
        <modified :enable="value.credential.company !== credential.company"/>
      </div>
      <div v-if='!credential.externalApi'>
        <label for="clientId">clientId</label>
        <input v-model="credential.clientId" id="clientId" name="clientId"/>
        <modified :enable="value.credential.clientId !== credential.clientId"/>
      </div>
      <div>
        <label v-if='credential.externalApi' for="clientSecret">Clé API</label>
        <label v-else for="clientSecret">clientSecret</label>
        <input v-model="credential.clientSecret" id="clientSecret" name="clientSecret"/>
        <modified :enable="value.credential.clientSecret !== credential.clientSecret"/>
      </div>
      <div v-if='credential.externalApi'>
        <label for="externalApiPath" title="par défaut : job-offers">chemin de l'api externe</label>
        <input v-model="credential.externalApiPath" id="externalApiPath" name="externalApiPath"/>
        <modified :enable="value.credential.externalApiPath !== credential.externalApiPath"/>
      </div>
      <div>
        <label for="submissionSource" title="par défaut : 1">submissionSource</label>
        <input v-model="credential.submissionSource" id="submissionSource" name="submissionSource"/>
        <modified :enable="value.credential.submissionSource !== credential.submissionSource"/>
      </div>
      <div>
        <label for="submissionSourceName" title='par défaut : "Hippolyte-rh"'>submissionSourceName</label>
        <input v-model="credential.submissionSourceName" id="submissionSourceName" name="submissionSourceName"/>
        <modified :enable="value.credential.submissionSourceName !== credential.submissionSourceName"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.cornerstone.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
